import React from "react";
import PropTypes from "prop-types";

import { Button } from "../Button";
import { CopyText } from "../CopyText";
import { TextLink } from "../TextLink";

import styles from "./CookieConsent.scss";

function CookieConsentDetail({
  children,
  onAcceptAll,
  onConfirmSelection,
  acceptAllCaption,
  confirmSelectionCaption,
  privacyPolicyUrl,
  privacyPolicyCaption,
  ...otherProps
}) {
  return (
    <div {...otherProps}>
      {children}

      <div className={styles.footer}>
        <div className={styles.actions}>
          <Button onClick={onAcceptAll} customClass={styles["action-button"]}>
            {acceptAllCaption}
          </Button>
          <Button
            variants={[Button.Variant.outline]}
            customClass={styles["action-button"]}
            onClick={onConfirmSelection}
          >
            {confirmSelectionCaption}
          </Button>
        </div>

        <CopyText tag="div" customClass={styles["privacy-link-container"]}>
          <TextLink href={privacyPolicyUrl}>{privacyPolicyCaption}</TextLink>
        </CopyText>
      </div>
    </div>
  );
}

CookieConsentDetail.defaultProps = {
  onAcceptAll: () => {},
  onConfirmSelection: () => {},
  privacyPolicyUrl: "",
  privacyPolicyCaption: "Datenschutzhinweis",
  acceptAllCaption: "Alle akzeptieren",
  confirmSelectionCaption: "Auswahl bestätigen",
};

CookieConsentDetail.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onAcceptAll: PropTypes.func,
  onConfirmSelection: PropTypes.func,
  privacyPolicyUrl: PropTypes.string,
  privacyPolicyCaption: PropTypes.string,
  acceptAllCaption: PropTypes.string,
  confirmSelectionCaption: PropTypes.string,
};

CookieConsentDetail.displayName = "CookieConsent.Detail";

export default CookieConsentDetail;
